import { isEnglishActive } from "@/lib/lang-mode";

export { setEnglishRouteMode } from "@/lib/lang-mode";

/** Engelska visar priser som "SEK 199", svenska (och övriga) som "199 kr". */
export function isEnglishPrice(): boolean {
  return isEnglishActive();
}

/** Formaterar ett heltalspris med rätt valutaplacering för aktuellt språk. */
export function formatSek(amount: number): string {
  return isEnglishPrice() ? `SEK ${amount}` : `${amount} kr`;
}

/** Decimaltal: punkt på engelska, komma på svenska. */
export function formatDecimal(amount: number, digits = 2): string {
  const s = amount.toFixed(digits);
  return isEnglishPrice() ? s : s.replace(".", ",");
}
